import { css } from '@emotion/react';
import { FormControlLabel, Stack, Switch, Typography } from '@mui/material';
import { useAtom } from 'jotai';
import { ChangeEvent, useCallback } from 'react';
import { cardStyles } from '../../../theme/component-styles';
import { showLeadershipCardOrgState } from './DataDisplayState';
import { EditConfigsLoader } from './EditDisplayConfigs';
import { panelConfigContainer } from './CommonConfig';

export function ProfileCustomization() {
  return (
    <Stack py='1rem'>
      <Typography variant='body2' color='text.secondary'>
        Here you can customize the type of information displayed. Changes will be applied to all company
        profiles across the platform.
      </Typography>
      <section css={panelConfigContainer}>
        <EditConfigsLoader />
        <LeadershipCardToggle />
      </section>
    </Stack>
  );
}

const leadershipCardContainer = css`
  margin-block: 1rem;
  padding: 0.5rem 1.5rem 0;
  display: grid;
  gap: 1rem;
  align-content: start;
`;

/* Sibling cards render sectionTitle (160%) inside a scale(0.5) overlay, so match the effective size. */
const leadershipCardTitle = css`
  font-size: 80%;
`;

const leadershipCardBody = css({
  ...cardStyles,
  display: 'grid',
  gap: '0.25rem',
  padding: '1rem',
});

function LeadershipCardToggle() {
  const [showLeadershipCard, setShowLeadershipCard] = useAtom(showLeadershipCardOrgState);

  const onToggle = useCallback(
    (_event: ChangeEvent<HTMLInputElement>, checked: boolean) => {
      setShowLeadershipCard(checked);
    },
    [setShowLeadershipCard]
  );

  return (
    <div css={leadershipCardContainer}>
      <Typography variant='body2' css={leadershipCardTitle}>
        Leadership
      </Typography>
      <div css={leadershipCardBody}>
        <FormControlLabel
          sx={{ ml: 0, width: 'fit-content' }}
          control={<Switch checked={showLeadershipCard} onChange={onToggle} size='small' />}
          label='Show Leadership card'
          labelPlacement='end'
        />
        <Typography variant='caption' color='text.secondary'>
          Controls the Leadership card on the Company Summary for all users.
        </Typography>
      </div>
    </div>
  );
}
